/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InputsDinamicos from 'src/components/InputsDinamicos';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import whitCotizacion from 'src/HOC/withCotizacion';
import useCotizacion from 'src/hooks/useCotizacion';
import useLoading from 'src/hooks/useLoading';
import usePageValidation from 'src/hooks/usePageValidation';
import { guardarLead } from 'src/services';

const ExtraDataForm = () => {
  const methods = useForm({ mode: 'onChange' });
  const { cotizacion, idCotizacion } = useCotizacion();
  const loadingFormProps = useLoading(false);

  const [pageProps, setPageProps] = useState({
    goBack: '',
    showBack: false,
    progreso: 70,
    inputs: [],
    methods,
    loadingFormProps,
    footerButton: {
      label: 'Continuar',
      onClick: () => {
        // guardarLead(idCotizacion, `EXTRA_DATA__CLICL`);
      },
      className: 'footer_button__continuar',
      classNameContainer: 'footer_container__continuar',
    },
  });

  const { isLoadingCallbacks, execEvent } = usePageValidation('extraDataForm');

  const init = useCallback(async () => {
    await execEvent('initCallback', { pageProps, setPageProps });
  }, [isLoadingCallbacks, cotizacion]);

  useEffect(() => {
    guardarLead(idCotizacion, `EXTRA_DATA_INGRESO`);
    init();
  }, [init]);

  return (
    <DIV stylePath="extraDataForm.globalStyles" className="container-fluid container-page">
      <NavbarHeader goBack={pageProps?.goBack} showBack={pageProps.showBack} />
      <HeaderPage progreso={pageProps.progreso} />
      <LoadingWrapper {...loadingFormProps.values} height="80%">
        <FormProvider {...methods}>
          <main className="row justify-content-center">
            <div className="col-12 col-md-9 col-lg-8 col-xl-7 mt-3">
              <div className="row">
                <InputsDinamicos inputs={pageProps.inputs} />
              </div>
            </div>
          </main>
        </FormProvider>
        <FooterButton {...pageProps.footerButton} />
      </LoadingWrapper>
    </DIV>
  );
};

export default whitCotizacion(ExtraDataForm);
